import axios from 'axios';
import { z } from 'zod';
import {
  ExamQuestionSchema,
  type ExamQuestion,
} from '@/modules/simulado/domain/entities/question.entity';
import type { OfficialExamDatasource } from '../repositories/official-exam.repository.impl';

/** Só o que esta LP lê da resposta: as questões. O `template` é descartado. */
const OfficialExamResponseSchema = z.object({
  questions: z.array(ExamQuestionSchema),
});

/**
 * A prova oficial comentada, na API da Aristo — **a rota do
 * `enamed-feedback-lp`** (`GET /v1/enamed-feedback/exam/:templateId`), que
 * devolve o mesmo objeto de questão do ensaio. Se a plataforma ganhar rota
 * própria, só o caminho muda.
 *
 * Fora do `apiClient`: outro host, rota pública.
 */
export class OfficialExamApiDatasource implements OfficialExamDatasource {
  private readonly baseUrl: string;

  constructor(baseUrl: string = import.meta.env.VITE_ARISTO_API_URL ?? '') {
    this.baseUrl = baseUrl.replace(/\/+$/, '');
  }

  async getQuestions(templateId: string): Promise<ExamQuestion[]> {
    if (!this.baseUrl) throw new Error('VITE_ARISTO_API_URL não configurada');
    if (!templateId)
      throw new Error('Template da prova oficial não configurado');

    const { data } = await axios.get<unknown>(
      `${this.baseUrl}/v1/enamed-feedback/exam/${encodeURIComponent(templateId)}`,
    );
    return OfficialExamResponseSchema.parse(data).questions;
  }
}
